import { createClient } from '@lumi.new/sdk'

export const lumi = createClient({
  projectId: 'p472389388225146880',
  apiBaseUrl: 'https://api.lumi.new',
  authOrigin: 'https://auth.lumi.new',
})
